
import React from 'react';
import './BusinessPage.css';
import SubTabBar, { SubTab } from '../../components/shared/SubTabBar';
import { useAppState, BusinessTab } from '../../context/AppStateContext';
import CrmPage from '../crm/CrmPage';
import CalendarPage from '../calendar/CalendarPage';
import BillingPage from '../billing/BillingPage';
import EmailPage from '../email/EmailPage';
import AnalyticsPage from '../analytics/AnalyticsPage';

const TABS: SubTab<BusinessTab>[] = [
  { id: 'customers', label: 'Customers', icon: 'customers' },
  { id: 'calendar', label: 'Calendar', icon: 'calendar' },
  { id: 'money', label: 'Money', icon: 'money' },
  { id: 'inbox', label: 'Inbox', icon: 'inbox', badge: 3 },
  { id: 'analytics', label: 'Analytics', icon: 'analytics' },
];

export default function BusinessPage() {
  const { appState, setAppState } = useAppState();

  const renderTab = () => {
    switch (appState.businessTab) {
      case 'customers': return <CrmPage />;
      case 'calendar': return <CalendarPage />;
      case 'money': return <BillingPage />;
      case 'inbox': return <EmailPage />;
      case 'analytics': return <AnalyticsPage />;
      default: return <CrmPage />;
    }
  };

  return (
    <div className="business-page">
      <SubTabBar
        tabs={TABS}
        active={appState.businessTab}
        onChange={tab => setAppState(s => ({ ...s, businessTab: tab }))}
      />
      <div className="business-page__content">
        {renderTab()}
      </div>
    </div>
  );
}
